import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { CREATE_PROFESSIONAL_SERVICE, GET_PROFESSIONAL_SERVICES } from '../../graphql/professional-services';
import ProfessionalServiceForm from './ProfessionalServiceForm';

const AddProfessionalService = () => {
  const navigate = useNavigate();

  const [createService, { loading, error }] = useMutation(CREATE_PROFESSIONAL_SERVICE, {
    refetchQueries: [{
      query: GET_PROFESSIONAL_SERVICES,
      variables: { pageIndex: 0, pageSize: 20, orderAsc: true, orderField: 'companyName', filters: {} }
    }],
    onCompleted: () => navigate('/sales/professional-services'),
    onError: (err) => {
      console.error('Error creating professional service:', err);
    }
  });

  const handleSubmit = (inputData) => {
    createService({ variables: { inputData } });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-semibold flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Professional Service
        </h1>
        <Link to="/sales/professional-services" className="flex items-center text-blue-600 hover:text-blue-800">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Services
        </Link>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error.message}
        </div>
      )}

      <div className="bg-white shadow rounded-lg p-6">
        <ProfessionalServiceForm
          submitLabel="Create Service"
          submitting={loading}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/sales/professional-services')}
        />
      </div>
    </div>
  );
};

export default AddProfessionalService;
